var ACTIVITY_DOM = {    
    updateActivityAlwaysDiscountDom() {
        let contDom = document.getElementById('ActAlwaysDiscountContentBox');
        let contentDom = document.getElementById('ActAlwaysDiscountBgBox');
        let height = window.innerHeight;
            height = contentDom ? height - contentDom.offsetHeight : height;
        console.log('updateActivityAlwaysDiscountDom-----', height);
        if(contDom) {
            contDom.style.height = height+10 + 'px';
        }
    },
    updateActivityDayLuckDom() {
        let contDom = document.getElementById('ActDayLuckContentBox');
        let contentDom = document.getElementById('ActDayLuckBgBox');
        let height = window.innerHeight;
            height = contentDom ? height - contentDom.offsetHeight : height;
        console.log('updateActivityDayLuckDom-----', height);
        if(contDom) {
            contDom.style.height = height+10 + 'px';
        }
    }
};

export {
    ACTIVITY_DOM
}
